// AdminMessages.js

import React, { useEffect, useState } from 'react';
import { db } from "../../firebase";
import { toast } from "react-toastify";
import "../../css/Admin-Messages/AdminMessages.css";
import { collection, deleteDoc, doc, getDocs, query } from 'firebase/firestore';

const AdminMessages = () => {
    const [allMessages, setAllMessages] = useState([]);

    async function fetchListings() {
        try {
            const projectRef = collection(db, 'messages');
            const q = query(projectRef);
            const querySnap = await getDocs(q);
            let messages = [];
            querySnap.forEach((doc) => {
                messages.push({
                    id: doc.id,
                    data: doc.data()
                });
            });
            setAllMessages(messages);
        } catch (error) {
            console.log(error);
        }
    }

    const handleDelete = async (messageId) => {
        if (window.confirm("Are you sure you want to delete this Message?")) {
            try {
                await deleteDoc(doc(db, "messages", messageId));
                toast.success("Message deleted successfully");
                fetchListings();
            } catch (error) {
                toast.error("Failed to delete Message");
            }
        }
    };

    useEffect(() => {
        fetchListings();
    }, []);

    return (
        <>
            <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                <div className="heading">
                    <h3>Messages</h3>
                </div>

                <div className="placed-orders">
                    <div className="box-container">
                        {allMessages.length === 0 ? (
                            <p className="empty">No Messages yet!</p>
                        ) : (
                            allMessages.map((message) => (
                                <div className="box" key={message.id}>
                                    <p>user id: <span className='msg'>{message.data.name}</span></p>
                                    <p>Email: <span className='msg'>{message.data.email}</span></p>
                                    <p>number: <span className='msg'>{message.data.phone}</span></p>
                                    <p>Message: <span className='msg'>{message.data.message}</span></p>
                                    <button className="delete-button-message" onClick={() => handleDelete(message.id)}>Delete</button>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default AdminMessages;
